(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plan-perfecto-collab-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-membership-signup')) {
  customElements.define('pp-membership-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-pp-open]');
        if (opener && this.contains(opener)) {
          this.querySelectorAll('[data-pp-pane]').forEach(pane => {
            pane.hidden = pane.dataset.ppPane !== opener.dataset.ppOpen;
          });
          this.opener = opener;
          this.dialog.showModal();
          this.querySelector('[data-pp-pane]:not([hidden]) input[type="text"]')?.focus();
        }
        if (event.target.closest('[data-pp-close]') && !this.busy) this.dialog.close();
        if (event.target === this.dialog && !this.busy) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('cancel', event => { if (this.busy) event.preventDefault(); });
      this.dialog.addEventListener('close', () => this.opener?.focus());
      this.querySelectorAll('.pp-signup__form').forEach(form => {
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.busy || !form.reportValidity()) return;
          const name = form.querySelector('input[type="text"]');
          name.value = name.value.trim();
          if (!name.value) { name.reportValidity(); return; }
          const button = form.querySelector('[data-pp-submit]');
          const error = form.querySelector('[data-pp-error]');
          const initial = button.innerHTML;
          this.busy = true;
          button.disabled = true;
          button.textContent = button.dataset.loading;
          error.hidden = true;
          try {
            const response = await fetch(form.action + '.js', {
              method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin'
            });
            if (!response.ok) throw new Error('cart');
            this.querySelector('[data-pp-checkout]').submit();
          } catch {
            error.hidden = false;
            button.disabled = false;
            button.innerHTML = initial;
            this.busy = false;
          }
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plan-perfecto-project-detail"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-pp-copy]').forEach((button) => {
      if (button.dataset.copyReady) return;
      button.dataset.copyReady = 'true';
      button.hidden = false;
      button.addEventListener('click', async () => {
        const panel = button.closest('[data-pp-donation]');
        const status = panel.querySelector('[role="status"]');
        try {
          await navigator.clipboard.writeText(button.dataset.ppCopy);
          status.textContent = panel.dataset.copied;
        } catch {
          status.textContent = panel.dataset.copyFailed;
        }
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
